import React, { Fragment } from 'react';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import './style.css';

const stepLabels = (currentStep, isMonthly) => {
  const activate = 'Activate ' + (isMonthly ? 'membership' : 'free trial');
  return currentStep === 3 ?
    ['Create free account', activate, 'Special Offer', 'Book first lesson'] :
    ['Create free account', activate, 'Book first lesson'];
};

const SignUpStep = ({ currentStep, location: { query } }) => {
  const isMonthly = query.plan && query.plan.includes('monthly');
  const steps = stepLabels(currentStep, isMonthly);

  return (
    <div className="sign-up-step d-flex align-items-center justify-content-center">
      {steps.map((step, index) => (
        <Fragment key={index}>
          <div className="sign-up-step__item d-flex align-items-center">
            {index + 1 < currentStep ? (
              <img
                className="mr-2"
                style={{ width: 24 }}
                src="/assets/green-check.png"
                alt="check"
              />
            ) : (
              <span
                className={classnames('sign-up-step__item-index mr-2', {
                  'sign-up-step__item-index--current': index + 1 === currentStep
                })}
              >
                {index + 1}
              </span>
            )}
            <h6 className="m-0 hidden-sm-down">{step}</h6>
          </div>
          {index < steps.length - 1 && <div className="sign-up-step__divider mx-2" />}
        </Fragment>
      ))}
    </div>
  );
};

export default withRouter(SignUpStep);



// WEBPACK FOOTER //
// ./src/components/SignUpStep/index.js